<script setup lang="ts">
import WrapperProductPage from './common/wrapper.vue';
import { useProductPage } from '../business/use-product-page';
interface Props {
  productId?: string;
  productName?: string;
  error?: any;
}

defineProps<Props>();

// Используем новый composable
const { onProductPageLeave } = useProductPage();

onBeforeRouteLeave(() => {
  onProductPageLeave();
});
</script>

<template>
  <wrapper-product-page :error="error" />
</template>

<style lang="stylus" scoped></style>
